// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import { verifyMagicLink } from '@/utils/auth';

const app = createApp(App);

router.beforeEach((to, from, next) => {
  const token = to.query.token;
  const emailu = to.query.emailUser;
  const typeUser = to.query.userType;
  if (token) {
    if (verifyMagicLink(token, emailu, typeUser)) {
      next({ path: to.path, query: {} });
    } else {
      next('/');
    }
  } else {
    next();
  }
});

app.use(router).mount('#app');